import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReference = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M22.8207 12.0492L22.8206 12.0492L22.8214 12.055L23.2491 15.2754C23.2513 15.2994 23.2453 15.316 23.2359 15.3292C23.2258 15.3436 23.2096 15.3566 23.187 15.3636C22.6087 15.4893 22.0125 15.5753 21.384 15.6535L21.0983 14.7963L21.0939 14.7831L21.089 14.7701C20.6835 13.6887 19.6593 12.9214 18.4698 12.9214C17.8382 12.9214 17.285 13.1348 16.8232 13.4647L16.8156 13.47L16.8083 13.4756L14.1056 15.5083C13.8437 15.4668 13.5853 15.4155 13.312 15.3608C13.2959 15.3563 13.2867 15.351 13.2819 15.3478C13.2764 15.3441 13.2733 15.3406 13.2711 15.3374C13.2681 15.333 13.257 15.3147 13.262 15.2724L13.262 15.2721L13.6404 12.0435L13.6404 12.0435L13.6407 12.0411C13.8241 10.4305 15.2159 9.2002 16.8303 9.2002H19.6048C21.2436 9.2002 22.6152 10.4059 22.8207 12.0492Z",
			stroke: "#232428",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.2258 3.73303C21.2258 5.38051 19.8903 6.71606 18.2428 6.71606C16.5953 6.71606 15.2598 5.38051 15.2598 3.73303C15.2598 2.08555 16.5953 0.75 18.2428 0.75C19.8903 0.75 21.2258 2.08555 21.2258 3.73303Z",
			stroke: "#232428",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.750779 21.5019L0.750819 21.5016L1.12874 18.2766C1.33562 16.6552 2.71056 15.4297 4.3443 15.4297H7.11885C8.75669 15.4297 10.1277 16.634 10.3343 18.276L10.7123 21.5016L10.7124 21.5019C10.7154 21.5275 10.7092 21.5449 10.6995 21.5587C10.6894 21.5731 10.6732 21.5861 10.6505 21.5931C9.09764 21.9315 7.44193 22.102 5.73157 22.102C3.99648 22.102 2.3657 21.9316 0.812645 21.5931C0.789998 21.5861 0.773789 21.5731 0.763676 21.5587C0.753908 21.5449 0.747764 21.5275 0.750779 21.5019Z",
			stroke: "#232428",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.71313 9.9635C8.71313 11.611 7.37758 12.9465 5.7301 12.9465C4.08262 12.9465 2.74707 11.611 2.74707 9.9635C2.74707 8.31602 4.08262 6.98047 5.7301 6.98047C7.37758 6.98047 8.71313 8.31602 8.71313 9.9635Z",
			stroke: "#232428",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4472 15.6904C18.4473 15.6905 18.4474 15.6905 18.4475 15.6905L18.4484 15.6933L18.4508 15.7006L19.8129 19.6858L19.8153 19.6928L19.8179 19.6997C19.8183 19.701 19.8187 19.7021 19.819 19.7031C19.818 19.7038 19.817 19.7042 19.8163 19.7044C19.8159 19.7045 19.8153 19.7046 19.8142 19.7046C19.8132 19.7046 19.8101 19.7044 19.8046 19.7027L19.8025 19.702L18.8188 19.3994L18.3672 19.2604L18.2029 19.7034C17.5415 21.4872 15.8294 22.6018 13.975 22.5782C15.0356 21.7204 15.8642 20.5806 16.3439 19.2101L16.5142 18.7234L16.0225 18.5681L15.0641 18.2654L15.0641 18.2654L15.0626 18.265C15.0611 18.2645 15.0599 18.264 15.059 18.2637C15.0585 18.2625 15.0579 18.2604 15.0574 18.2575C15.0563 18.2508 15.0573 18.2446 15.0588 18.2405C15.0595 18.2387 15.0602 18.2374 15.0611 18.2362C15.0618 18.2353 15.0632 18.2335 15.0661 18.2312L18.4372 15.6903C18.4377 15.69 18.438 15.6899 18.438 15.6899L18.4392 15.6896C18.4409 15.6893 18.4439 15.6894 18.4472 15.6904Z",
			stroke: "#232428"
		})
	]
});
const ForwardRef = forwardRef(SvgReference);
export { ForwardRef as ReactComponent };
